export enum EnquiryFormFields {
  MARKETING_INFORMATION = 'root_marketingInformation',
  LEGAL_DISCLAIMER = 'root_legalDisclaimer',
  PRIVACY_POLICY = 'root_privacyPolicy',
  TERMS_AND_CONDITION = 'root_termsAndConditions',
}
